var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ContainerType } from '@/models/Container';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from "vue-property-decorator";
var DashboardComponent = /** @class */ (function (_super) {
    __extends(DashboardComponent, _super);
    function DashboardComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DashboardComponent.prototype, "containers", {
        get: function () {
            var containers = this.$store.state.containers.list;
            if (this.onTrip) {
                return containers;
            }
            return containers.filter(function (el) { return el.type != ContainerType.Trip; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "dirtyCount", {
        get: function () {
            return this.$store.state.containers.dirtyCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "onTrip", {
        get: function () {
            return this.$store.state.containers.onTrip;
        },
        enumerable: true,
        configurable: true
    });
    DashboardComponent.prototype.onContainersChange = function (containers) {
        //preselect default container
        this.showDefaultContianer(containers);
    };
    DashboardComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$store.dispatch('loadContainers', this.$dao);
                return [2 /*return*/];
            });
        });
    };
    DashboardComponent.prototype.showBadge = function (container) {
        switch (container.type) {
            case ContainerType.Dirty:
                return this.dirtyCount;
            default:
                return false;
        }
    };
    DashboardComponent.prototype.beforeRouteUpdate = function (to, from, next) {
        if (to.name === 'panel') {
            var defaultContainer = this.containers.filter(function (el) { return el.type == ContainerType.Default; });
            next(this.getUrl(defaultContainer.pop()));
            return;
        }
        next();
    };
    DashboardComponent.prototype.showDefaultContianer = function (containers) {
        var defaultContainer = containers.filter(function (el) { return el.type == ContainerType.Default; });
        if (defaultContainer.length && this.$route.name == 'panel') {
            this.$router.replace(this.getUrl(defaultContainer.pop()));
        }
    };
    DashboardComponent.prototype.logout = function () {
        var _this = this;
        this.$dao.logout().then(function () {
            _this.$router.replace({ name: 'login' });
        });
    };
    DashboardComponent.prototype.isActive = function (container) {
        return this.$route.name == 'container' && this.$route.params['id'] == container.id;
    };
    DashboardComponent.prototype.getUrl = function (container) {
        return { name: 'container', params: { id: container.id } };
    };
    __decorate([
        Watch('containers')
    ], DashboardComponent.prototype, "onContainersChange", null);
    DashboardComponent = __decorate([
        Component
    ], DashboardComponent);
    return DashboardComponent;
}(Vue));
export default DashboardComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/dashboard/component.ts
// module id = null
// module chunks = 